import React from "react";
import { FiAlertTriangle, FiX } from "react-icons/fi";

/**
 * Amber/danger banner with retry and optional dismiss actions.
 *
 * @param {Object} props
 * @param {string} [props.message='Something went wrong while loading.'] - Error message text.
 * @param {() => void} props.onRetry - Callback fired when Retry button is clicked.
 * @param {() => void} [props.onDismiss] - Optional callback fired when dismiss X is clicked.
 * @param {string} [props.className] - Extra classes.
 */
export const RetryBanner = ({
  message = "Something went wrong while loading.",
  onRetry,
  onDismiss,
  className = ""
}) => {
  return (
    <div
      className={`
        flex items-center gap-3 px-4 py-3 rounded-lg
        bg-danger-bg text-danger-dark border border-danger/30
        ${className}
      `}
    >
      <FiAlertTriangle className="w-5 h-5 flex-shrink-0" aria-hidden="true" />

      <span className="flex-1 text-sm">{message}</span>

      <button
        type="button"
        onClick={onRetry}
        className="
          min-h-[44px] px-3 text-xs font-semibold
          bg-danger text-white rounded
          hover:bg-danger-dark transition-colors
          flex-shrink-0 inline-flex items-center
        "
      >
        Retry
      </button>

      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="
            min-h-[44px] min-w-[44px] flex items-center justify-center
            text-gray-500 hover:text-gray-700
            transition-colors flex-shrink-0
          "
          aria-label="Dismiss"
        >
          <FiX className="w-4 h-4" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};
